import React from 'react';
function Footer() {
  return <div className="footer">Libreria</div>;
}
export default Footer;
